module.exports = __webpack_public_path__ + "img/1488439259.0279221b.jpg";